import {Injectable} from '@angular/core';
import {Storage} from '../_interfaces/storage';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class StorageService {

  private themeColorApp: BehaviorSubject<Storage.DisplayTheme> = new BehaviorSubject(null);
  public themeColorApp$: Observable<Storage.DisplayTheme> = this.themeColorApp.asObservable();

  updateColorTheme(theme: Storage.DisplayTheme) {
    theme = (theme === 'auto') ? this.getOSTheme() : theme;
    this.themeColorApp.next(theme);
  }

  getFontThemeApp(): Storage.DisplayFontTheme {
    const displayFontOfStorage = localStorage.getItem('displayFontStorage') as Storage.DisplayFont;
    const displayThemeOfStorage = localStorage.getItem('displayThemeStorage') as Storage.DisplayTheme;

    const currentDisplayFont = displayFontOfStorage !== null ? displayFontOfStorage : 'medium';
    let currentDisplayTheme = displayThemeOfStorage !== null ? displayThemeOfStorage : 'light';

    if(currentDisplayTheme === 'auto') currentDisplayTheme = this.getOSTheme();

    return {
      currentDisplayFont: currentDisplayFont,
      currentDisplayFontParse: this.getCurrentFontStyle(currentDisplayFont),
      currentDisplayTheme
    };
  }

  getOSTheme(): Storage.DisplayTheme {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  getCurrentFontStyle(currentDisplayFont: Storage.DisplayFont): string {
    if(currentDisplayFont === 'small') return 'font-s';
    if(currentDisplayFont === 'medium') return 'font-m';
    if(currentDisplayFont === 'large') return 'font-l';
    return 'font-l';
  }

  setDisplayFont(display: Storage.DisplayFont){
    localStorage.setItem('displayFontStorage', display);
  }

  setDisplayTheme(theme: Storage.DisplayTheme){
    theme = (theme === 'auto') ? this.getOSTheme() : theme;
    localStorage.setItem('displayThemeStorage', theme);
  }

}
